import type { ReactNode } from "react";
import { UserCheck, Clock, Users } from "lucide-react";
import { StepInfoRow } from "../../StepInfoRow";
import { getString, getNumber } from "../helpers";
import type { SummaryTranslator } from "../types";

export function getCheckpointSummary(config: Record<string, unknown>, t: SummaryTranslator): ReactNode[] {
  const items: ReactNode[] = [];

  const title = getString(config.title);
  const approvalQuorum = getNumber(config.approval_quorum);
  const expiresInSeconds = getNumber(config.expires_in_seconds);
  const approvers = Array.isArray(config.approvers)
    ? (config.approvers as Array<Record<string, string>>)
    : [];

  if (title) {
    items.push(
      <StepInfoRow
        key="title"
        icon={<UserCheck className="size-3.5" />}
        label={t("summaries.checkpoint.label_title")}
        value={title}
      />
    );
  }

  if (approvers.length > 0) {
    items.push(
      <StepInfoRow
        key="approvers"
        icon={<Users className="size-3.5" />}
        label={t("summaries.checkpoint.label_approvers")}
        value={t("summaries.checkpoint.approvers_count", { count: approvers.length })}
      />
    );
  }

  if (approvalQuorum !== undefined) {
    const policyLabel =
      approvalQuorum === 1
        ? "Any one"
        : approvalQuorum >= approvers.length
        ? "All"
        : "Majority";
    items.push(
      <StepInfoRow
        key="policy"
        icon={<UserCheck className="size-3.5" />}
        label={t("summaries.checkpoint.label_policy")}
        value={policyLabel}
      />
    );
  }

  if (expiresInSeconds) {
    const minutes = Math.round(expiresInSeconds / 60);
    items.push(
      <StepInfoRow
        key="timeout"
        icon={<Clock className="size-3.5" />}
        label={t("summaries.checkpoint.label_timeout")}
        value={t("summaries.checkpoint.timeout_value", { minutes })}
      />
    );
  }

  return items;
}
